export default __webpack_public_path__ + "static/media/Amazon_logo.svg.7b0e54b3.webp";